<template>
  <div>
    <div
      v-resize="setContentHeight"
      id="helpDiv"
      style="color: white"
      :class="[
        { 'inset-box-shadow': !isMobileOrStandaloneMode },
        onsiteMode ? 'bg-blue-dark' : 'bg-blue-dark',
      ]"
    >
      <v-toolbar id="helpHeader" dark color="transparent" elevation="0">
        <v-btn icon @click="goBack" style="z-index: 1">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        <v-toolbar-title
          style="position: absolute; left: -4px; width: 100vw"
          class="text-center headlinex"
        >
          <strong>Getting Started</strong>
        </v-toolbar-title>
      </v-toolbar>

      <div
        ref="helpScrollable"
        class="scrollable box-shadow-inset"
        style="overflow-x: hidden"
      >
        <v-list
          dense
          three-line
          flat
          tile
          dark
          color="transparent"
          class="mt-0"
          disabledx
        >
          <v-list-item-group>
            <v-list-item
              v-if="windowSettings.showCovidInfo"
              key="1"
              :ripple="false"
            >
              <v-row style="color: #f44336; background-color: white">
                <v-col :cols="leftCols">
                  <v-btn fab dark color="red" small elevation="0">
                    <v-icon>mdi-alert-outline</v-icon>
                  </v-btn>
                </v-col>
                <v-col :cols="rightCols" class="font-weight-bold text-shadowx">
                  <v-list-item-content
                    >From 1 December 2021, Vaccination-Differentiated Safe
                    Management Measures will be implemented at all libraries,
                    Archives Reading Room, Former Ford Factory and National
                    Library Building’s Level 5 Study
                    Lounge.</v-list-item-content
                  >
                </v-col>
              </v-row>
            </v-list-item>
            <v-col
              v-if="windowSettings.showCovidInfo"
              :offset="leftCols"
              class="pa-0"
            >
              <v-divider></v-divider>
            </v-col>

            <!-- <v-list-item
              v-if="windowSettings.showBloombergEndingSoonInfo"
              key="111"
              :ripple="false"
            >
              <v-row
                style="background-color: white"
                :style="'color: ' + $vuetify.theme.themes.light.primary"
              >
                <v-col :cols="leftCols">
                  <v-btn fab dark color="primary" small elevation="0">
                    <v-icon>mdi-information-outline</v-icon>
                  </v-btn>
                </v-col>
                <v-col :cols="rightCols" class="font-weight-bold text-shadowx">
                  <v-list-item-content
                    >We are sorry that Bloomberg Terminal service will not be
                    available from 27 October 2021. If you have any queries,
                    please send an email to our Customer Relations Officer at
                    <a href="mailto: enquiry@nlb.gov.sg"
                      >enquiry@nlb.gov.sg</a
                    ></v-list-item-content
                  >
                </v-col>
              </v-row>
            </v-list-item>
            <v-col
              v-if="windowSettings.showBloombergEndingSoonInfo"
              :offset="leftCols"
              class="pa-0"
            >
              <v-divider></v-divider>
            </v-col> -->

            <v-list-item key="2" :ripple="false">
              <v-row>
                <v-col :cols="leftCols">
                  <v-btn fab dark color="orange" small>
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                </v-col>
                <v-col :cols="rightCols">
                  <v-list-item-content>
                    <p class="font-weight-bold">Search for booking slots</p>
                    <ul>
                      <li v-if="visitBookingEnabled">
                        Click the button to select the type of booking that you
                        need.
                      </li>
                      <li>
                        Search for booking slots that best match your criteria.
                      </li>
                      <li>
                        Seats may be booked one day in advance. Booking slots are open at 12pm daily.
                      </li>
                    </ul>
                  </v-list-item-content>
                </v-col>
              </v-row>
            </v-list-item>
            <v-col :offset="leftCols" class="pa-0">
              <v-divider></v-divider>
            </v-col>

            <v-list-item key="3" :ripple="false">
              <v-row>
                <v-col :cols="leftCols">
                  <v-btn fab dark color="orange" small>
                    <v-icon>mdi-calendar-check</v-icon>
                  </v-btn>
                </v-col>
                <v-col :cols="rightCols">
                  <v-list-item-content>
                    <p class="font-weight-bold">Book a seat<span v-if="visitBookingEnabled">/visit</span></p>
                    <ul>
                      <li>
                        Login via mylibrary username to make a booking. An email
                        confirming your transaction(s) will be sent to the email
                        address associated with the mylibrary username.
                      </li>
                      <li>
                        Do note that the email may appear in your Junk/Spam inbox.
                      </li>
                    </ul>

                    <p class="font-weight-bold pt-3">Seat booking</p>
                    <ul>
                      <li>
                        Your seat will be assigned by the system, check “My
                        Bookings” tab for your seat number.
                      </li>
                      <li>
                        Seat booking timeslots are at 15-minute intervals.
                        Minimum booking duration is 30 minutes.
                        <span v-if="windowSettings.showBloombergInfo"
                          >(For Bloomberg Terminal, booking timeslots are at
                          1-hour intervals only)</span
                        >
                      </li>
                      <!-- <li>
                        Your maximum daily booking quota is 4 hours across all
                        library seats<span
                          v-if="windowSettings.showBloombergInfo"
                        >
                          and 1 hour for the Bloomberg Terminal.</span
                        ><span v-else>.</span>
                      </li> -->
                      <li>
                        If the seat you have booked is occupied by another patron, 
                        please show your booking confirmation to the patron. 
                        Do remember to take your belongings with you once your booking ends. 
                        Another patron may have booked the seat after you.
                      </li>
                      <li v-if="visitBookingEnabled">
                        If you have booked a seat beforehand, you do not need to
                        make a separate visit booking to the libraries included
                        in this seat booking system. Show your seat booking
                        details to enter the library.
                      </li>
                    </ul>

                    <p v-if="visitBookingEnabled" class="font-weight-bold pt-3">Visit booking</p>
                    <ul>
                      <li v-if="visitBookingEnabled">
                        Visit booking timeslots are dependent on the site you
                        are visiting. Please refer to
                        <div style="word-break: break-all; line-height: 24px">
                          <a :href="planYourVisitLink" class="white--text">
                            {{ planYourVisitLink.replace("https://www.", "") }}
                          </a>
                        </div>
                        for more details.
                      </li>
                      <li v-if="visitBookingEnabled">
                        Visit bookings are limited to 1 booking per branch per
                        day.
                      </li>
                    </ul>
                  </v-list-item-content>
                </v-col>
              </v-row>
            </v-list-item>
            <v-col :offset="leftCols" class="pa-0">
              <v-divider></v-divider>
            </v-col>

            <v-list-item key="4" :ripple="false">
              <v-row>
                <v-col :cols="leftCols">
                  <v-btn fab dark color="orange" small>
                    <v-icon>mdi-checkbox-marked-circle-outline</v-icon>
                  </v-btn>
                </v-col>
                <v-col :cols="rightCols">
                  <v-list-item-content>
                    <p class="font-weight-bold">
                      Check-in at your seat <span v-if="visitBookingEnabled">(Not required for visits)</span> 
                    </p>
                    <ul>
                      <li>
                        Check-ins are needed to confirm that you are showing up
                        for the booking made. You will need to verify that you
                        are on-site at the library.
                      </li>
                      <li>
                        There are two ways to check-in:
                        <ol>
                          <li>
                            Allow the webpage to verify that your current
                            location is at the library you have made a booking
                            for, or
                          </li>
                          <li>
                            Click the orange icon in the bottom-right corner,
                            then scan the QR code placed at the area you have
                            booked for or at your assigned seat.
                          </li>
                        </ol>
                      </li>
                      <li>
                        You may check-in 15 mins before your booking starts to
                        secure it.
                      </li>
                      <li>
                        You must check-in within 14 minutes from the start time 
                        of your booking, or your booking will be automatically cancelled. 
                        [For example, if your booking begins at 1pm, you have 
                        until 1:14pm to check-in].
                      </li>
                    </ul>
                  </v-list-item-content>
                </v-col>
              </v-row>
            </v-list-item>
            <v-col :offset="leftCols" class="pa-0">
              <v-divider></v-divider>
            </v-col>

            <v-list-item key="5" :ripple="false">
              <v-row>
                <v-col :cols="leftCols">
                  <v-btn fab dark color="orange" small>
                    <v-icon>mdi-expand-all</v-icon>
                  </v-btn>
                </v-col>
                <v-col :cols="rightCols">
                  <v-list-item-content>
                    <p class="font-weight-bold">
                      Extend your seat booking<span
                        v-if="windowSettings.showBloombergInfo"
                      >
                        (Not applicable for Bloomberg Terminal bookings)</span
                      >
                    </p>
                    <ul>
                      <li>
                        You can extend the booking for your seat only in the
                        last 15 minutes of your booking.
                      </li>
                      <li>
                        Seat bookings can be extended for 1 hour each time, and
                        only if your current seat is available for the next
                        hour.
                      </li>
                      <li>
                        If you have run out of daily booking quota, you can
                        still make up to 2 additional extensions each day.
                      </li>
                    </ul>
                  </v-list-item-content>
                </v-col>
              </v-row>
            </v-list-item>
            <v-col :offset="leftCols" class="pa-0">
              <v-divider></v-divider>
            </v-col>

            <v-list-item key="6" :ripple="false">
              <v-row>
                <v-col :cols="leftCols">
                  <v-btn fab dark color="orange" small>
                    <v-icon>mdi-close-thick</v-icon>
                  </v-btn>
                </v-col>
                <v-col :cols="rightCols">
                  <v-list-item-content>
                    <p class="font-weight-bold">Cancel your bookings</p>
                    <ul>
                      <li>Cancel bookings that you no longer need.</li>
                      <li>
                        At the point of cancellation, any unused booking
                        timeslots will be returned to your daily booking
                        quota.<span v-if="windowSettings.showBloombergInfo">
                          However, if you do not show up for your Bloomberg
                          Terminal bookings, you will not be able to make
                          another booking that day.</span
                        >
                      </li>
                      <li>
                        If you cancel a seat booking that has already started,
                        it will be a partial cancellation. Your cancelled
                        timeslots can be booked by other users.
                      </li>
                      <li v-if="windowSettings.showBloombergInfo">
                        Bloomberg Terminal bookings: If you cancel a booking
                        that had already started, or if your booking was
                        automatically cancelled by the system due to elapsed
                        time, you will not be able to re-book for that day.
                        Bookings made for the Bloomberg Terminal are separate
                        from the Seat Booking quota.
                      </li>
                      <li v-if="visitBookingEnabled">
                        Visit quota will not be returned once booking has
                        already started.
                      </li>
                    </ul>
                  </v-list-item-content>
                </v-col>
              </v-row>
            </v-list-item>
            <v-col :offset="leftCols" class="pa-0">
              <v-divider></v-divider>
            </v-col>

            <v-list-item key="7" :ripple="false">
              <v-row>
                <v-col :cols="leftCols">
                  <v-btn
                    fab
                    dark
                    color="orange"
                    small
                    @click="gotoOnsiteDetector"
                  >
                    <v-icon>mdi-thumb-up-outline</v-icon>
                  </v-btn>
                </v-col>
                <v-col :cols="rightCols">
                  <v-list-item-content>
                    The Seat Booking System is used to manage the use of library
                    seats in selected areas. Help us improve this system by
                    leaving your feedback at
                    <div style="word-break: break-all; line-height: 24px">
                      <a :href="feedbackLink" class="white--text">
                        {{ feedbackLink.replace("https://", "") }}
                      </a>
                    </div>
                  </v-list-item-content>
                </v-col>
              </v-row>
            </v-list-item>

            <!-- <v-list-item key="1">
    <v-row>
      <v-col :cols="leftCols">
        <v-btn fab dark color="orange" small>
          <v-icon>mdi-logout-variant</v-icon>
        </v-btn>
      </v-col>
      <v-col :cols="rightCols">
        <v-list-item-content>Log out.</v-list-item-content>
      </v-col>
    </v-row>
  </v-list-item>-->
          </v-list-item-group>
        </v-list>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Help",
  data: () => ({
    leftCols: 3,
    rightCols: 9,
    feedbackLink: window.$settings.feedbackLink,
    planYourVisitLink: window.$settings.planYourVisitLink,
    clickCount: 0,
    clickTimer: null,
  }),
  computed: {
    ...mapGetters(["visitBookingEnabled"])
  },
  methods: {
    setContentHeight() {
      if (this.$refs.helpScrollable) {
        const heights = this.heights();
        const contentHeight = heights.screen - heights.toolbar - heights.noticeBarHeight;

        this.$refs.helpScrollable.style.height = contentHeight + "px";
      }
    },
    gotoOnsiteDetector() {
      this.clickCount++;

      if (!this.clickTimer) {
        this.clickCount = 1;

        this.clickTimer = setTimeout(() => {
          this.clickCount = 0;
          this.clickTimer = null;
        }, 700);
      } else if (this.clickTimer && this.clickCount >= 5) {
        this.clickCount = 0;
        this.clickTimer = null;
        this.$router.push({ name: "OnsiteDetector" });
      }
    },
  },
  activated() {
    this.$nextTick(() => this.setContentHeight());

    //const statusBarColor = this.onsiteMode ? "#0d47a1" : "#004d40";
    const statusBarColor = this.onsiteMode ? "#0047BB" : "#0047BB";
    
    this.setStatusBackgroundBarColor(statusBarColor);

    this.clickCount = 0;
    this.clickTimer = null;
  },
  deactivated() {
    this.setThemeColorByMode();
  },
};
</script>

<style scoped>
.v-list-item {
  margin-top: 12px;
  margin-bottom: 12px;
}
</style>

<style>
#helpDiv .v-list-item {
  padding: 0 16px;
}

#helpDiv .col {
  display: flex;
  align-items: center;
  justify-content: center;
}

#helpDiv .col.col-3 {
  text-align: center;
  vertical-align: middle !important;
}

#helpDiv .v-list-item__icon {
  margin-right: 0 !important;
}

#helpDiv .v-list-item__icon .v-icon {
  font-size: 30px !important;
}

#helpDiv .v-btn--fab.v-size--small {
  height: 48px;
  width: 48px;
}

#helpDiv li {
  padding: 5px;
  line-height: 24px;
}

#helpDiv ol {
  list-style-type: lower-roman;
}
</style>
